export default __webpack_public_path__ + "static/media/ico-linkedin.72222335.svg";